export const GPT_PAGE_NAMES = {
    NONE: 'other',
    STARTPAGE: 'startPage',
    MY_TRADERA: 'myTradera',
    SYI: 'syi',
    SRP: 'srp',
    CRP: 'crp',
    LAST_CHANCE: 'lastChance',
    NEW_TODAY: 'newToday',
    BLP: 'blp',
    VIP: 'vip',
    SHOP_SELLER_ITEMS: 'shopSellerItems',
    SELLER_ITEMS: 'sellerItems',
    BRAND_LIST: 'brand',
    CATEGORY_LIST: 'category',
    FALLBACK: 'fallback',
    MUSIKHJALPEN: 'musikhjalpen',
    WISHLIST: 'wishlist',
    TILLSAMMANS: 'tillsammans',
    CAUSE: 'cause'
};
